module.exports = __webpack_public_path__ + "img/ic-form-btn-register-wise.6f892602.svg";